import type { CityConfig } from "../city-template/types";

export const grandJunctionConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Grand Junction",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "grand-junction",
  route: "/cities/grand-junction",
  title: "Emergency Passport Grand Junction, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Grand Junction, Colorado — as fast as 24 hours. Same-day courier processing for Grand Junction, Fruita, Clifton, Palisade, and all Mesa County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Grand Junction, CO",
  heroSubtitle: "International trip booked and your passport just expired? Business conference abroad and you need documents fast? We help Grand Junction residents — from downtown professionals to Colorado Mesa University students to Western Slope families — get their passports as fast as 24 hours. A+ BBB rated registered courier. 240 miles closer to Denver than you think with our courier service.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Grand%20Junction%20Colorado%20scenic%20panoramic%20view%20with%20the%20Colorado%20National%20Monument%20red%20rock%20canyons%20and%20towering%20sandstone%20formations%20in%20warm%20golden%20afternoon%20light%2C%20the%20Book%20Cliffs%20stretching%20across%20the%20horizon%2C%20the%20Grand%20Mesa%20visible%20in%20the%20distance%20as%20the%20largest%20flat%20top%20mountain%20in%20the%20world%2C%20the%20Colorado%20River%20winding%20through%20the%20valley%20below%2C%20high%20desert%20landscape%20with%20juniper%20and%20sagebrush%2C%20dramatic%20western%20sky%20with%20scattered%20clouds%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people&width=1800&height=700&seq=grand-junction-hero-001&orientation=landscape",
  heroImageAlt: "Grand Junction Colorado with Colorado National Monument red rock canyons and the Book Cliffs",
  geoPosition: "39.0639;-108.5506",
  geoPlacename: "Grand Junction, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 240 miles east via I-70 — about 4 hours",
  },
  nearbyCitiesZips: [
    { name: "Grand Junction", zips: "81501, 81503, 81504, 81505, 81506, 81507" },
    { name: "Fruita", zips: "81521" },
    { name: "Clifton", zips: "81520" },
    { name: "Palisade", zips: "81526" },
    { name: "Orchard Mesa", zips: "81503" },
    { name: "Redlands", zips: "81507" },
    { name: "Mack", zips: "81525" },
    { name: "Loma", zips: "81524" },
    { name: "De Beque", zips: "81630" },
    { name: "Collbran", zips: "81624" },
    { name: "Mesa", zips: "81643" },
    { name: "Gateway", zips: "81522" },
    { name: "Glade Park", zips: "81523" },
    { name: "Whitewater", zips: "81527" },
    { name: "Montrose", zips: "81401, 81403" },
    { name: "Delta", zips: "81416" },
    { name: "Rifle", zips: "81650" },
    { name: "Parachute", zips: "81635" },
    { name: "Battlement Mesa", zips: "81636" },
    { name: "Silt", zips: "81652" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for urgent Western Slope departures — skip the 4-hour Denver drive" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — the smart alternative for Colorado's Western Slope" },
    { icon: "ri-flight-takeoff-line", title: "GJT Airport Gateway", desc: "Grand Junction Regional Airport with daily connections to major hubs" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in the Grand Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Colorado Springs", route: "/cities/colorado-springs" },
    { name: "Fast passport renewal in Montrose and Delta", route: "/cities/grand-junction" },
    { name: "Urgent passport services for Fruita and Palisade", route: "/cities/grand-junction" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services for all of Mesa County", route: "/cities/grand-junction" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Grand Junction remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Grand Junction's Western Slope location — 240 miles from the Colorado Passport Agency — makes our courier service the only practical option for fast passport processing. Skip the 4-hour drive over the Rocky Mountains.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Mesa County and the Western Slope from Rifle to the Utah border",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Grand Junction and the Grand Valley. From downtown Main Street to the Redlands and Orchard Mesa, from the vineyards of Palisade to the mountain biking trails of Fruita — we serve every corner of Mesa County and the surrounding Western Slope communities.",
  nearbyCitiesIntro: "We serve Grand Junction and all nearby communities including Fruita, Clifton, Palisade, Orchard Mesa, Redlands, Mack, Loma, De Beque, Collbran, and Gateway. We also serve Montrose, Delta, Rifle, Parachute, and the entire Colorado River Valley.",
  howItWorksIntro: "Most Grand Junction travelers complete everything online and ship documents overnight. Our couriers handle all State Department delivery — saving you the 480-mile roundtrip drive to Denver through Glenwood Canyon and over Vail Pass.",
  mistakesIntro: "Grand Junction is the Western Slope's largest city with travelers serving the energy industry, healthcare, agriculture, and tourism sectors. Here are the most common passport mistakes we see from Grand Junction-area travelers.",
  testimonialsIntro: "Grand Junction travelers — from healthcare professionals to Colorado Mesa University faculty to energy industry workers — trust us when departure is imminent.",
  faqIntro: "Have questions about expedited passports in Grand Junction, CO? Here are the most common ones we hear from Western Slope travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive — ship from Grand Junction", "Ideal for Western Slope business and leisure travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned travel from GJT", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (4 hours each way)", "Glenwood Canyon & Vail Pass — weather dependent"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Grand Junction travelers with immediate departure needs — as fast as 24 hours. Our couriers make the 240-mile trip so you don't have to.",
      bullets: ["24–48 hour turnaround available", "GJT and DEN flight departure support", "Energy and healthcare industry travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Grand Junction adults with a passport issued within the last 15 years. Skip the post office entirely.",
      bullets: ["No clerk visit required for most renewals", "Courier or mail-in options", "Returned to your Grand Valley address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Grand Junction residents and Western Slope families — including CMU students and new citizens.",
      bullets: ["Acceptance facility scheduling in Grand Junction", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Grand Junction residents — whether lost at home or during Colorado travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Grand Junction and Mesa County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Grand Junction and Mesa County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Grand Junction CO", description: "Urgent passport processing for Grand Junction Colorado travelers with immediate departure needs from GJT or connecting hubs." },
    { name: "Expedited Passport Renewal Grand Junction CO", description: "Fast passport renewal for Grand Junction Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Grand Junction CO", description: "New passport application services for Grand Junction Colorado residents applying for their first passport." },
    { name: "Child Passport Grand Junction CO", description: "Minor passport services for Grand Junction Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Tom H.",
      location: "Grand Junction, CO — Redlands",
      rating: 5,
      text: "Energy conference in Dubai with 10 days notice and my passport was expired. Fast Passport Center had my renewal in 3 days. I shipped from FedEx on Horizon Drive and never had to think about that 8-hour roundtrip to Denver.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rebecca M.",
      location: "Fruita, CO",
      rating: 5,
      text: "Family trip to Costa Rica with two weeks notice. Three passports — one renewal and two first-time for the kids. Done in 5 days. The courier service is a lifesaver for Western Slope families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Dr. Allen P.",
      location: "Grand Junction, CO — Orchard Mesa",
      rating: 5,
      text: "Medical mission trip to Guatemala with 5 days notice. Fast Passport Center processed my emergency passport in 2 days. Flying through GJT to Denver and then Guatemala City — everything was seamless.",
      service: "Emergency Passport",
    },
    {
      name: "Carol S.",
      location: "Palisade, CO",
      rating: 5,
      text: "Lost my passport the week before a wine tour trip to France. Fast Passport Center replaced it in 48 hours. The overnight shipping from the Grand Valley was flawless.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "gj-1",
      name: "Grand Junction Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "241 N 4th St",
      city: "Grand Junction",
      state: "CO",
      zip: "81501",
      phone: "(970) 245-2306",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Grand Junction",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Grand Junction acceptance facility. Appointments required. Extended afternoon hours compared to mountain locations.",
      icon: "ri-mail-line",
    },
    {
      id: "gj-2",
      name: "Horizon Drive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "735 Horizon Dr",
      city: "Grand Junction",
      state: "CO",
      zip: "81506",
      phone: "(970) 243-4873",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Grand Junction, near GJT airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for north Grand Junction residents and travelers near the airport. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "gj-3",
      name: "Fruita Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "103 N Coulson St",
      city: "Fruita",
      state: "CO",
      zip: "81521",
      phone: "(970) 858-7492",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fruita, approximately 12 miles west of Grand Junction",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fruita and western Mesa County residents. Good alternative with easier parking than downtown Grand Junction.",
      icon: "ri-mail-line",
    },
    {
      id: "gj-4",
      name: "Clifton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3241 F Rd",
      city: "Clifton",
      state: "CO",
      zip: "81520",
      phone: "(970) 434-7391",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Clifton, approximately 8 miles east of Grand Junction",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Clifton, Palisade, and east Mesa County residents. Limited hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "gj-5",
      name: "Mesa County Clerk — Grand Junction",
      type: "County Clerk Passport Acceptance",
      address: "200 S Spruce St",
      city: "Grand Junction",
      state: "CO",
      zip: "81501",
      phone: "(970) 244-1680",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Grand Junction — Mesa County Courthouse",
      website: "https://www.mesacounty.us/",
      websiteLabel: "Mesa County Clerk",
      notes: "County clerk passport acceptance with extended hours. Full-service facility. Accepts walk-ins but appointments preferred.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 240 mi to Denver, 4hr each way", fpc: "No — ship from Grand Junction" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Mountain Corridor Travel", agency: "Glenwood Canyon closures risk", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long — Western Slope Mail Is Slow",
      description: "Standard mail from Grand Junction to the passport processing center takes longer than from Front Range cities. Routine processing can take 10–13 weeks from the Western Slope. Always use expedited courier service.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at drugstores sometimes don't meet State Department standards. Photos must be exactly 2×2 inches on a plain white background — no colored backdrops.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early",
      description: "Grand Junction facilities serve the entire Western Slope. Summer travel season creates long wait times. Book 2–3 weeks ahead for appointments.",
    },
    {
      icon: "ri-road-map-line",
      title: "Attempting the Denver Drive for Emergency",
      description: "Driving 240 miles to the Colorado Passport Agency means an 8-hour roundtrip through Glenwood Canyon, Vail Pass, and the Eisenhower Tunnel. Road closures and weather can derail the entire trip. Use courier service instead.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Not Planning GJT Connections",
      description: "Grand Junction Regional Airport (GJT) has limited direct flights. Most international travel requires a connection through Denver (DEN), Salt Lake City (SLC), Dallas (DFW), or Phoenix (PHX). Factor connection time into your passport planning.",
    },
    {
      icon: "ri-global-line",
      title: "Assuming Western Slope Processing Is the Same",
      description: "Mail from Grand Junction to passport processing centers takes significantly longer than from Front Range cities. Always build in extra buffer or use our courier service for guaranteed turnaround.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Grand Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in Grand Junction, Fruita, or Clifton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Western Slope paperwork." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — you skip the 480-mile Denver roundtrip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Grand Junction address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Grand Junction, CO?", a: "Fast Passport Center offers emergency passport processing in Grand Junction, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 240-mile, 4-hour drive over the Rocky Mountains to the Colorado Passport Agency." },
    { q: "Does Grand Junction have its own passport agency?", a: "No — Grand Junction does not have a regional passport agency. The nearest is the Colorado Passport Agency (approximately 240 miles east via I-70 — a 4-hour drive through Glenwood Canyon and over Vail Pass). Fast Passport Center's courier service is the practical and efficient solution for Western Slope travelers." },
    { q: "What airport does Grand Junction use for international flights?", a: "Grand Junction Regional Airport (GJT) offers daily flights to Denver (DEN), Salt Lake City (SLC), Dallas (DFW), Phoenix (PHX), and other regional hubs. All international travel requires a connection through a major hub. Always verify passport validity for your full itinerary beyond GJT." },
    { q: "Can you help with passports in Fruita, Palisade, or Clifton?", a: "Absolutely. Fast Passport Center serves all of Mesa County including Fruita, Palisade, Clifton, Orchard Mesa, Redlands, Mack, Loma, De Beque, Collbran, and Gateway. We also serve Montrose, Delta, Rifle, Parachute, and the entire Colorado River Valley." },
    { q: "Is mail service slower from the Western Slope?", a: "Yes — standard mail from Grand Junction to passport processing centers on the East Coast takes significantly longer than from Front Range cities. This is one reason our courier service is so valuable: we bypass standard mail entirely and use overnight courier shipping with guaranteed delivery." },
    { q: "How much does an expedited passport cost in Grand Junction, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and travel needs." },
    { q: "Where can I get passport photos in Grand Junction?", a: "Walgreens (multiple locations including North Avenue and Patterson Road), CVS Pharmacy on Horizon Drive, and FedEx Office on North Avenue all offer passport photo services. Costco on 1st Street also provides photos. Must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Colorado Mesa University students and faculty?", a: "Yes. Fast Passport Center serves all of Mesa County including CMU students and faculty traveling internationally for study abroad, research, or conferences. We understand academic travel schedules and can help with tight deadlines." },
    { q: "What about travelers from Montrose or Delta County?", a: "Fast Passport Center serves all Western Slope communities including Montrose, Delta, Olathe, and the Uncompahgre Valley. Our overnight shipping labels work from any UPS or FedEx location in the region." },
    { q: "Can I get a passport if I'm from the Ute Mountain Ute or Southern Ute reservations?", a: "Yes. Fast Passport Center serves all residents of the Western Slope and Four Corners region. Contact us for guidance on any specific documentation needs based on your circumstances." },
  ],
  photoLocations: [
    { name: "Walgreens — North Avenue", address: "2501 North Ave, Grand Junction, CO 81501", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walgreens — Patterson Road", address: "2901 Patterson Rd, Grand Junction, CO 81504", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Horizon Drive", address: "605 Horizon Dr, Grand Junction, CO 81506", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — North Avenue", address: "2454 Highway 6 and 50, Grand Junction, CO 81505", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
    { name: "Costco — Grand Junction", address: "590 24 1/2 Rd, Grand Junction, CO 81505", hours: "Mon–Fri: 10AM–8:30PM, Sat: 9:30AM–6PM", website: "https://www.costco.com/" },
    { name: "UPS Store — Fruita", address: "598 Kokopelli Blvd, Fruita, CO 81521", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Grand Junction (Mesa County)", address: "222 S 6th St, Grand Junction, CO 81501", hours: "Mon–Fri: 8AM–5PM", note: "Full-service Mesa County DMV. REAL ID and driver's license renewals. Appointment strongly recommended.", featured: true },
    { name: "DMV — Clifton", address: "3225 I-70 Business Loop, Clifton, CO 81520", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV location serving east Mesa County. REAL ID processing available. Less crowded than downtown.", featured: false },
  ],
  airports: [
    {
      code: "GJT",
      name: "Grand Junction Regional Airport",
      distance: "4 miles north of downtown Grand Junction",
      address: "2828 Walker Field Dr, Grand Junction, CO 81506",
      note: "Primary airport for Western Colorado. Daily flights to DEN, SLC, DFW, PHX. All international travel requires connection through a major hub. The closest commercial airport serving the Western Slope.",
      flightUrl: "https://www.gjairport.com/",
      flightLabel: "GJT Flight Info",
      featured: true,
    },
    {
      code: "MTJ",
      name: "Montrose Regional Airport",
      distance: "65 miles south of Grand Junction via US-50",
      address: "2100 Airport Rd, Montrose, CO 81401",
      note: "Regional airport serving Montrose, Telluride, and the San Juan Mountains. Seasonal flights and connections to DEN, DFW, and PHX.",
      flightUrl: "https://www.montroseairport.com/",
      flightLabel: "MTJ Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "270 miles east of Grand Junction via I-70",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. 4.5-hour drive or 45-minute connecting flight from GJT.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};